module.exports = __webpack_public_path__ + "InterstateWGL-Regular.d5fdaf6c0a2407cd7c3b.woff2";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/InterstateWGL-Regular.woff2
// module id = ../../../../../src/assets/layout/fonts/InterstateWGL-Regular.woff2
// module chunks = styles